import {Injectable, inject} from '@angular/core';
import {CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {environment} from "../../../../environment";

/**
 * Guard global pour gérer les redirections système
 *
 * Ce guard gère :
 * - Mode maintenance : redirection vers /maintenance si activé
 * - Routes legacy /admin/* : redirection vers les nouvelles routes
 */
@Injectable({
    providedIn: 'root'
})
export class GlobalRedirectGuard implements CanActivate {
    private readonly router = inject(Router);

    canActivate(_, state: RouterStateSnapshot): boolean {
        const url = state.url;

        // Mode maintenance : rediriger toutes les routes sauf /maintenance
        if (this.shouldRedirectToMaintenance(url)) {
            this.router.navigate(['/maintenance']);
            return false;
        }

        // Sortie du mode maintenance : rediriger /maintenance vers /
        if (this.shouldExitMaintenance(url)) {
            this.router.navigateByUrl('/');
            return false;
        }

        // Routes legacy /admin/* : redirection vers les nouvelles routes
        if (this.shouldRedirectLegacyAdmin(url)) {
            const newUrl = url.replace('/admin', '');
            this.router.navigateByUrl(newUrl);
            return false;
        }

        // Route /admin seule : redirection vers /
        if (url === '/admin') {
            this.router.navigateByUrl('/');
            return false;
        }

        return true;
    }

    /**
     * Vérifie si on doit rediriger vers la page de maintenance
     */
    private shouldRedirectToMaintenance(url: string): boolean {
        return environment.MAINTENANCE && !url.startsWith('/maintenance');
    }

    /**
     * Vérifie si on doit sortir de la page de maintenance
     */
    private shouldExitMaintenance(url: string): boolean {
        return !environment.MAINTENANCE && url.startsWith('/maintenance');
    }

    /**
     * Vérifie si on doit rediriger une route legacy /admin/*
     */
    private shouldRedirectLegacyAdmin(url: string): boolean {
        return url.startsWith('/admin/');
    }
}
